import {
  Component,
  input,
  output,
  ChangeDetectionStrategy
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-verify-email-banner',
  templateUrl: './verify-email-banner.component.html',
  styleUrls: ['./verify-email-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe]
})
export class VerifyEmailBannerComponent {
  public readonly emailResent = input(false);
  public readonly emailVerified = input(false);

  public readonly resend = output<void>();

  public onResend() {
    this.resend.emit();
  }
}
